import { render, staticRenderFns } from "./OrgRoles.vue?vue&type=template&id=28a8d5f4&"
import script from "./OrgRoles.vue?vue&type=script&lang=ts&"
export * from "./OrgRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports